const ded = `
<h1>Política de Uso Aceptable</h1>
<p><strong>DressDown.me</strong><br><em>Fecha de entrada en vigor: 01.05.2025</em></p>

<h2>Disposiciones Generales</h2>
<p>Esta Política de Uso Aceptable (en adelante — la Política) define los modos permitidos y prohibidos de uso del sitio <a href="https://dressdown.me">https://dressdown.me</a> (en adelante — el Sitio). Al usar el Sitio, usted acepta cumplir con esta Política, así como con otros términos y políticas aplicables, incluyendo la Política de Privacidad y los Términos de Uso.</p>

<h2>Uso Permitido</h2>
<p>Los usuarios se comprometen a:</p>
<ul>
  <li>Usar el Sitio exclusivamente para fines legales y de acuerdo con la legislación aplicable de la Unión Europea y otras jurisdicciones.</li>
  <li>Respetar los derechos de otros usuarios y terceros, incluyendo derechos a la privacidad, propiedad intelectual e integridad personal.</li>
  <li>Proporcionar información veraz al registrarse y utilizar el Sitio.</li>
</ul>

<h2>Uso Prohibido</h2>
<p>Se prohíbe utilizar el Sitio para:</p>
<ul>
  <li>Violación de la legislación: cargar, publicar o distribuir contenido que infrinja leyes y normativas locales, nacionales o internacionales.</li>
  <li>Daño a menores: publicar, distribuir o acceder a materiales que contengan imágenes o descripciones de menores en un contexto sexual, así como cualquier acción que pueda dañar a menores.</li>
  <li>Distribución de software malicioso: transmitir virus, troyanos, gusanos, keyloggers, spyware u otro código malicioso.</li>
  <li>Violación de derechos de propiedad intelectual: publicar contenido que infrinja derechos de autor, marcas registradas, patentes u otros derechos de propiedad intelectual de terceros.</li>
  <li>Discriminación y odio: publicar materiales que contengan calumnias, insultos, amenazas o discriminación por raza, sexo, religión, nacionalidad, discapacidad, orientación sexual o edad.</li>
  <li>Fraude y engaño: participar en esquemas fraudulentos, phishing, difusión de información falsa o engañar a otros usuarios.</li>
  <li>Violaciones de seguridad: intentar acceder sin autorización a sistemas, datos o cuentas de otros usuarios, así como interferir en el funcionamiento del Sitio o su infraestructura.</li>
</ul>

<h2>Estándares de Contenido</h2>
<p>Los usuarios se comprometen a no publicar contenido que:</p>
<ul>
  <li>Sea ilegal, dañino, ofensivo, obsceno o que viole normas morales públicas.</li>
  <li>Contenga información falsa o engañosa.</li>
  <li>Infrinja derechos de terceros, incluyendo derechos de autor, marcas o derechos a la privacidad.</li>
  <li>Promueva violencia, odio, discriminación o actividades ilegales.</li>
  <li>Contenga materiales sexuales que representen o describan a menores.</li>
</ul>

<h2>Restricciones de Edad</h2>
<p>El Sitio DressDown.me está destinado exclusivamente a usuarios mayores de 18 años. Para evitar el acceso de menores a contenido para adultos, aplicamos un conjunto de medidas de verificación de edad. En particular, se utilizan servicios externos como AI Vision Apps – Age Detection API, integrados a través de la plataforma RapidAPI, así como tecnologías de análisis de imágenes, incluyendo DeepFace. Estas herramientas permiten evaluar automáticamente la edad del usuario según las imágenes proporcionadas, garantizando el cumplimiento de la legislación vigente y las políticas internas de la plataforma.</p>

<h2>Infracciones y Consecuencias</h2>
<p>En caso de incumplimiento de esta Política, nos reservamos el derecho a:</p>
<ul>
  <li>Eliminar o bloquear el acceso al contenido infractor.</li>
  <li>Suspender o terminar el acceso del usuario al Sitio sin previo aviso.</li>
  <li>Reportar la infracción a las autoridades competentes, si así lo exige la ley.</li>
  <li>Adoptar otras medidas necesarias para proteger el Sitio, sus usuarios y garantizar el cumplimiento legal.</li>
</ul>

<h2>Cambios en la Política</h2>
<p>Podemos actualizar esta Política periódicamente. Todos los cambios entran en vigor desde su publicación en el Sitio. Recomendamos revisar la Política regularmente para estar informado sobre las condiciones actuales.</p>

<h2>Información de Contacto</h2>
<p>Si tiene preguntas o comentarios sobre esta Política, por favor contáctenos:<br>
Correo electrónico: <a href="mailto:dressdown@dressdown.me">dressdown@dressdown.me</a></p>
`;

export default ded
